// import store from "~/store";

export default function auth() {
  // if (!store.getters["auth/token"]) {
  //   return { name: "auth.login" };
  // }
  return null;
}
